import {Action} from '@ngrx/store';
import { IsReadStatus } from '../reducers/is_read.reducers';

export enum IsReadActionTypes {
    UPDATE_DIRECT_CHAT_UNREAD_IDS = '[Id Read Feature] update direct chat unread ids',
    UPDATE_GLOBAL_PROJECTS_IS_READ = '[Id Read Feature] update all global projects is read or not',
    UPDATE_GLOBAL_PROJECT_IS_READ = '[Is Read Feature] update global project is read or not',
    SET_CURRENT_CONVERSATION_ID = '[Is Read Feature] set current conversation id'
}

export class UpdateDirectChatUnreadIdsAction implements Action {
    readonly type = IsReadActionTypes.UPDATE_DIRECT_CHAT_UNREAD_IDS;

    constructor(public payload: {unreadIds: number[]}) {
    }
}

export class UpdateGlobalProjectsIsReadAction implements Action {
    readonly type = IsReadActionTypes.UPDATE_GLOBAL_PROJECTS_IS_READ;

    constructor(public payload: IsReadStatus[]) {
    }
}

export class UpdateGlobalProjectIsReadAction implements Action {
    readonly type = IsReadActionTypes.UPDATE_GLOBAL_PROJECT_IS_READ;

    constructor(public payload: IsReadStatus) {

    }
}

export class SetCurrentConversationIdAction implements Action {
    readonly type = IsReadActionTypes.SET_CURRENT_CONVERSATION_ID;

    constructor(public payload: {conversationId: number | null } = {conversationId: null}) {
    }
}

export type IsReadActions = UpdateDirectChatUnreadIdsAction
    | UpdateGlobalProjectIsReadAction
    | UpdateGlobalProjectsIsReadAction
    | SetCurrentConversationIdAction;
